module.exports = __webpack_public_path__ + "img/容器 2740.21309c0b.png";